<script>
  export let autor;
  export let first;
  export let last;
  export let onUp;
  export let onDown;
  export let onRemove;
</script>

<style>
  img.arrow {
    width: 10px;
    height: 10px;
    cursor: pointer;
  }

  td.options {
    text-align: right;
    width: 30px;
  }

  td.options img {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  td.arrows {
    text-align: center;
    width: 15px;
    text-align: left;
  }

  td.user {
    width: 50px;
    text-align: center;
  }

  td.user img {
    width: 25px;
    height: 25px;
  }
</style>

<tr>
  {#if !first || !last}
    <td class="arrows">
      {#if !first}
        <img
          class="arrow"
          src="/images/revista/up.svg"
          alt="Up Icon"
          on:click={onUp} />
      {/if}
    </td>
    <td class="arrows">
      {#if !last}
        <img
          class="arrow"
          src="/images/revista/down.svg"
          alt="Down Icon"
          on:click={onDown} />
      {/if}
    </td>
  {/if}
  <td class="user">
    <img class="user" src="/images/revista/user.svg" alt="User Icon" />
  </td>
  <td>{autor.nombre + ' ' + autor.apellido1 + ' ' + autor.apellido2}</td>
  <td>{autor.firma}</td>
  <td>{autor.institucion}</td>
  <td>{autor.email}</td>
  <td class="options">
    <img
      src="/images/revista/close.svg"
      alt="Remove Icon"
      on:click={onRemove} />
  </td>
</tr>
